module.exports = __webpack_public_path__ + "media/application/images/svgs/long-arrow-6a546f9189ddf537c736238dab8171f9.svg";